import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { ScrollText, FileText, ShieldCheck } from "lucide-react";
import api from "@/lib/api";
import { fileUrl } from "@/lib/upload";
import { ContactLinks } from "@/components/ContestRules";
import Logo from "@/components/Logo";

export default function PublicRules() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const [c, setC] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.contestPublic(id).then(setC).catch(() => setErr(true)); api.trackRulesView(id, params.get("src") || "link"); }, [id]); // eslint-disable-line react-hooks/exhaustive-deps
  const logo = c ? fileUrl(c.logo_file_id) || c.logo_url : null;
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="public-rules-page">
      <header className="border-b border-border"><div className="max-w-2xl mx-auto px-5 py-4 flex items-center gap-3"><Logo className="h-10" /><div><p className="text-xs uppercase tracking-widest text-primary font-semibold">Regolamento</p><h1 className="font-display font-bold text-lg">{c?.name || (err ? "Concorso non trovato" : "Caricamento…")}</h1></div></div></header>
      {c && (
        <main className="max-w-2xl mx-auto px-5 py-8 space-y-6">
          {logo && <img src={logo} alt="" className="h-16 w-auto object-contain rounded-xl bg-white p-1" />}
          {c.description && <p className="text-sm text-muted-foreground">{c.description}</p>}
          {c.rules_file_id && (
            <a href={fileUrl(c.rules_file_id)} target="_blank" rel="noreferrer" className="flex items-center gap-3 rounded-2xl border border-border bg-card p-4 hover:border-primary" data-testid="public-rules-pdf">
              <span className="h-11 w-11 rounded-xl bg-primary/15 grid place-items-center"><FileText className="h-5 w-5 text-primary" /></span>
              <div><p className="font-semibold">Regolamento completo (PDF)</p><p className="text-xs text-muted-foreground">Tocca per aprire o scaricare</p></div>
            </a>
          )}
          {c.rules_text && (
            <section className="rounded-2xl border border-border bg-card p-5" data-testid="public-rules-text">
              <h2 className="font-semibold flex items-center gap-2 mb-3"><ScrollText className="h-4 w-4 text-amber-400" /> Regolamento</h2>
              <p className="text-sm whitespace-pre-wrap leading-relaxed">{c.rules_text}</p>
            </section>
          )}
          {!c.rules_text && !c.rules_file_id && <p className="text-muted-foreground" data-testid="public-rules-empty">Nessun regolamento pubblicato per questo concorso.</p>}
          {(c.contact_email || c.contact_phone) && <section className="rounded-2xl border border-border bg-card p-5 space-y-2"><h2 className="font-semibold">Contatti</h2><ContactLinks c={c} /></section>}
          <a href={`/privacy/${c.id}`} className="inline-flex items-center gap-1.5 text-sm underline text-primary" data-testid="public-rules-privacy-link"><ShieldCheck className="h-4 w-4" /> Informativa privacy</a>
        </main>
      )}
    </div>
  );
}
